export const SUBSCRIPTION_PRICES = {
  pro: "1",
  concierge: "2",
};

const SUBSCRIPTION_PLANS = [
  {
    name: "Free Tier",
    slug: "free",
    priceId: 0,
    cost: 0,
    examsAnalyses: 5,
    paywallDefaultOption: "pro",
  },
  {
    name: "Allheartz Pro",
    slug: "pro",
    priceId: 1,
    cost: 100,
    examsAnalyses: 50,
    paywallDefaultOption: "concierge",
  },
  {
    name: "Concierge Tier",
    slug: "concierge",
    priceId: 2,
    cost: 3000,
    examsAnalyses: 10000,
    paywallDefaultOption: "concierge",
  },
];

export const getSubscriptionPlan = (
  planParam: number,
  hasLifetimeAccess: boolean
) => {
  if (hasLifetimeAccess) {
    return {
      name: "Lifetime Access",
      slug: "lifetime",
      priceId: 10,
      cost: 0,
      examsAnalyses: Infinity,
      paywallDefaultOption: "pro",
    };
  }
  if (!planParam || Number.isNaN(planParam)) {
    return SUBSCRIPTION_PLANS[0];
  }
  return (
    SUBSCRIPTION_PLANS.find((plan) => plan.priceId === planParam) ||
    SUBSCRIPTION_PLANS[0]
  );
};
